import { duration } from "moment";
import { apiSlice } from "./apiSlice";

export const statutoryApprovalSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllStatutoryApproval: builder.query({
            query: (params) => ({
                url: `StatutoryTracker`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["Approval"],
        }),

        // Export all data (without pagination) in Excel File
        getExportAllStatutoryApproval: builder.query({
            query: (params) => ({
                url: `StatutoryTracker`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

        getSingleStatutoryApprovalDetails: builder.query({
            query: ({ statutoryTrackerId, params }) => ({
                url: `StatutoryTracker/${statutoryTrackerId}`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),

        createStatutoryApproval: builder.mutation({
            query: ({ body }) => ({
                url: `StatutoryTracker`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["Approval"],
        }),

        updateStatutoryApproval: builder.mutation({
            query: ({ body }) => ({
                url: `StatutoryTracker`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["Approval"],
        }),


        getAllStatutoryApprovalCount: builder.query({
            query: (params) => ({
                url: `StatutoryTracker/summary`,
                params,
            }),
            invalidatesTags: ["Approval"],
        }),

        getPhaseSummary: builder.query({
            query: (projectId) => ({
                url: `StatutoryTracker/project/${projectId}/phase-distribution`,
            }),
            invalidatesTags: ["Approval"],
        }),
        getTypeSummaryByPhase: builder.query({
            query: ({projectId,phase}) => ({
                url: `StatutoryTracker/project/${projectId}/category-distribution?phase=${phase}`,
            }),
            invalidatesTags: ["Approval"],
        }),


        getAllStatutoryApprovalDurationCount: builder.query({
            query: (projectId) => ({
                url: `StatutoryTracker/project/${projectId}/approval-duration`,
            }),
            invalidatesTags: ["Approval"],
        }),

        getAllStatutoryApprovalDurationData: builder.query({
            query: (params) => ({
                url: `StatutoryTracker/approval-duration/list`,
                params
            }),
            invalidatesTags: ["Approval"],
        }),
        getAllStatutoryApprovalDurationData: builder.query({
            query: (params) => ({
                url: `StatutoryTracker/approval-duration/list?projectId=${params.ProjectId}&durationTag=${params.durationTag}`,
                url: `StatutoryTracker/approval-duration/list`,
                params
            }),
            invalidatesTags: ["Approval"],
        }),

    }),
});

export const {
    useGetAllStatutoryApprovalQuery,
    useLazyGetAllStatutoryApprovalQuery,
    useLazyGetSingleStatutoryApprovalDetailsQuery,
    useCreateStatutoryApprovalMutation,
    useUpdateStatutoryApprovalMutation,
    useGetAllStatutoryApprovalCountQuery,
    useLazyGetAllStatutoryApprovalCountQuery,
    useGetPhaseSummaryQuery,
    useLazyGetTypeSummaryByPhaseQuery,
    useGetAllStatutoryApprovalDurationCountQuery,
    useGetAllStatutoryApprovalDurationDataQuery,
    useLazyGetExportAllStatutoryApprovalQuery

} = statutoryApprovalSlice;